// @flow
import React from 'react'
import * as url from 'url'

const SSOOrgError = (): any => {
  const siteUrl = window.location.href
  const parsedUrl = url.parse(siteUrl, true)
  const orgName = parsedUrl.query ? parsedUrl.query.org : ''
  const ssoLink = parsedUrl.query ? parsedUrl.query.ssolink : ''
  return (
    <div className='login'>
      <span className='login__accent' />
      <div className='login__header'>
        <h3 className='login__title'>Unauthorized</h3>
        {parsedUrl && parsedUrl.host &&
          <h4 className='login__subtitle'>Direct login is not allowed for {orgName}. Please click <a href={ssoLink} className='SSO-link'>{parsedUrl.host + '/' + ssoLink}</a> for Single Sign On.</h4>}
      </div>
    </div>
  )
}

export default SSOOrgError
